<template>
  <custom-select
    :list="itemsList"
    :data="data"
    :search-is-loading="isLoading"
    label="Доступные регионы"
    search-label="Поиск регионов"
    search
    chips
    multiple
    @change="onChange"
    @search="debouncedFetch"
  />
</template>

<script>
import { mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import CustomSelect from '@/components/ui/custom-select';

export default {
  name: 'regions-select',
  components: {
    CustomSelect,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    itemsList: {
      type: Array,
      required: true,
    },
    value: [Object, Array],
    data: [Object, Array],
  },
  data: () => ({
    isLoading: false,
  }),
  created() {
    const debouncedFetch = debounce(this.onSearch, 300);

    this.debouncedFetch = (...args) => {
      this.isLoading = true;
      debouncedFetch(...args);
    };
  },
  methods: {
    ...mapActions('regions/searchSelect', ['getList']),

    async onSearch(query) {
      const rawQuery = query.toLowerCase();

      if (!rawQuery || rawQuery.length < 3) {
        await this.getList();
        this.isLoading = false;
        return;
      }

      this.lastQuery = rawQuery;

      try {
        await this.getList({ query: rawQuery });
      } catch (e) {
        console.error(e);
      } finally {
        this.isLoading = false;
      }

      if (this.lastQuery !== rawQuery) {
        this.onSearch(this.lastQuery);
      }
    },

    onChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>
